import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import styles from "../../../styles/global.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"
import NavigationItem from "./navigation_item"
import SubNavItems from "./sub_nav_items"
import { useGetNav } from "../../../hooks/useGetNav"

export default function Navigation() {
  const { all_pages } = useStaticQuery(graphql`
    query AllPagesQuery {
      all_pages: allMarkdownRemark {
        edges {
          node {
            frontmatter {
              page_id
              title
            }
          }
        }
      }
    }
  `)

  // Get Navigation from content/pages
  const { navigation } = useGetNav()

  // Set local state to manage menu icon
  const [localState, setLocalState] = useState({
    menu_active: false,
    selected_tab: "",
  })

  // Set menu icon
  let menu_icon
  localState.menu_active ? (menu_icon = faTimes) : (menu_icon = faBars)

  function handleMenuClick(e) {
    e.preventDefault()
    // If mobile menu not active, switch to active
    if (!localState.menu_active) {
      setLocalState({
        menu_active: true,
      })
    } else {
      setLocalState({
        menu_active: false,
      })
    }
    // Toggle navigation active class
    const nav = document.querySelector(`#${styles.mainNavigation}`)
    nav.classList.toggle(styles.mainNavigationActive)
    const mobileicon = document.querySelector(`#${styles.mobileIcon}`)
    mobileicon.classList.toggle(styles.mobileIconActive)
  }

  function handleMouseEnter(nav_item) {
    if (!localState.menu_active) {
      let tab_name
      // If label, set nav_item name to label, else set to page name
      nav_item.label ? (tab_name = nav_item.label) : (tab_name = nav_item.page)
      setLocalState({
        ...localState,
        selected_tab: tab_name,
      })
    }
  }
  function handleMouseLeave() {
    setLocalState({
      ...localState,
      selected_tab: "",
    })
  }

  return (
    <>
      <nav id={styles.mainNavigation}>
        <ul className={`${styles.flexWrapper}`}>
          {navigation
            ? navigation.map((item, i) => {
                if (all_pages) {
                  let page_name = all_pages.edges.find(
                    p => p.node.frontmatter.page_id === item.nav_item.page_id
                  )
                  if (page_name) {
                    item.nav_item.page = page_name.node.frontmatter.title
                  }
                }
                return (
                  <li key={i}>
                    <div
                      role="button"
                      onMouseEnter={() => handleMouseEnter(item.nav_item)}
                      onMouseLeave={() => handleMouseLeave()}
                      tabIndex={i}
                    >
                      <NavigationItem
                        nav_item={item.nav_item}
                        all_pages={all_pages}
                      />
                      <SubNavItems
                        nav_item={item.nav_item}
                        selected_tab={localState.selected_tab}
                        all_pages={all_pages}
                      />
                    </div>
                  </li>
                )
              })
            : null}
        </ul>
      </nav>
      <button
        aria-label="Menu"
        id={styles.mobileIcon}
        onClick={e => handleMenuClick(e)}
      >
        <FontAwesomeIcon icon={menu_icon} />
      </button>
    </>
  )
}
